export enum ActivityType {
	engineer = 1,
	techSupport = 2,
	warehouse = 3,
}
